// 家族管理画面: メンバー一覧 + 招待リンク発行
import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { FamilyMember, listFamilyMembers } from '../lib/db';

export default function FamilyPage() {
  const { user, family, signOut } = useAuth();
  const [members, setMembers] = useState<FamilyMember[]>([]);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!family) return;
    listFamilyMembers(family.id).then(setMembers);
  }, [family]);

  if (!family) return null;

  const inviteUrl = `${window.location.origin}/join?token=${family.inviteToken}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(inviteUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const handleShareLine = () => {
    const text = encodeURIComponent(
      `「${family.name}」のタスク管理に参加してください！\n${inviteUrl}`
    );
    window.open(`https://line.me/R/msg/text/?${text}`, '_blank');
  };

  return (
    <>
      <div className="card">
        <h2>👨‍👩‍👧 家族グループ「{family.name}」</h2>
        <p className="muted">あなたのユーザー: {user?.email}</p>
      </div>

      <div className="card">
        <h2>家族を招待</h2>
        <p className="description">奥様・お子様のスマホでこのリンクを開くと参加できます。</p>
        <div className="form-row">
          <label>招待リンク</label>
          <input type="text" readOnly value={inviteUrl} onClick={(e) => e.currentTarget.select()} />
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button className="btn btn-primary" onClick={handleCopy}>
            {copied ? '✓ コピー済み' : '📋 リンクをコピー'}
          </button>
          <button className="btn btn-secondary" onClick={handleShareLine}>
            💬 LINEで送る
          </button>
        </div>
      </div>

      <div className="card">
        <h2>メンバー（{members.length}人）</h2>
        <div className="task-list">
          {members.map((m) => (
            <div key={m.userId} className="task-item">
              <div className="info">
                <div className="msg">
                  {m.userId === user?.id ? '👤 あなた' : '👥 メンバー'}
                </div>
                <div className="meta">
                  {m.role === 'owner' ? '👑 オーナー' : '👤 メンバー'}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="card">
        <h2>ログアウト</h2>
        <button className="btn btn-danger" onClick={signOut}>
          ログアウトする
        </button>
      </div>
    </>
  );
}
